import { providerType } from '@repo/shared/types';
export var hasMerchantLiberisOffers = function (merchantResponseData) { var _a; return (_a = merchantResponseData.data.offers) === null || _a === void 0 ? void 0 : _a.some(function (offer) { return offer.provider === providerType.enum.liberis; }); };
